import { render, staticRenderFns } from "./ControlDashboardPage.vue?vue&type=template&id=a518a948"
import script from "./ControlDashboardPage.vue?vue&type=script&lang=ts"
export * from "./ControlDashboardPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a518a948')) {
      api.createRecord('a518a948', component.options)
    } else {
      api.reload('a518a948', component.options)
    }
    module.hot.accept("./ControlDashboardPage.vue?vue&type=template&id=a518a948", function () {
      api.rerender('a518a948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/ControlDashboardPage.vue"
export default component.exports